import { render, staticRenderFns } from "./MultiStepEventEncounter.vue?vue&type=template&id=1c4798f9&scoped=true"
import script from "./MultiStepEventEncounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiStepEventEncounter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MultiStepEventEncounter.vue?vue&type=style&index=0&id=1c4798f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4798f9",
  null
  
)

export default component.exports